export enum LinkedinTaskStatusEnum {
  Open = 'OPEN',
  Done = 'DONE',
  Cancelled = 'CANCELLED',
  Skipped = 'SKIPPED',
}
